export function getMaImagesLibraryEnvironment(): string {
    return import.meta.env.VITE_MA_IMAGES_ENVIRONMENT;
}

export function getMaImagesLibraryS3PathPrefix(): string {
    return `zyAuthor/MaImages/${getMaImagesLibraryEnvironment()}/Library`;
}

export function getMaImagesLibraryBaseUrl(): string {
    return `${import.meta.env.VITE_IMAGE_URL}${getMaImagesLibraryS3PathPrefix()}/`;
}
